module.exports = __webpack_public_path__ + "static/media/video.61a81c26.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/vid/video.mp4
// module id = 577
// module chunks = 0